import { api } from 'utility';
import {
  getInvoiceCrodUrl,
  getReportSaleInvoiceUrl,
  getInvoiceSaleListUrl,
  getDetaileInvoicePaymentUrl,
  getInvoicePaymentSmsUrl,
  getCloseInvoiceListUrl,
  getCloseInvoiceByIdUrl,
  getRDandDetaileInvoiceUrl,
  getCancellInvoiceListUrl,
  getPaymentServiceUrl
} from 'URLs';

class InvoiceServices {
  async cancelInvoice(invoiceId) {
    return api.delete(getRDandDetaileInvoiceUrl(invoiceId));
  }

  async cancelInvoiceList(invoiceIds) {
    return api.post(getCancellInvoiceListUrl(), invoiceIds);
  }

  async closelInvoice(invoiceId) {
    return api.post(getCloseInvoiceByIdUrl(invoiceId));
  }

  async closeInvoiceList(invoiceIds) {
    return api.post(getCloseInvoiceListUrl(), invoiceIds);
  }

  async paymentLink(uniqueNumber) {
    return api.post(getPaymentServiceUrl(), { uniqueNumber, redirectUri: '' });
  }

  async payment(invoiceId) {
    return api.post(getDetaileInvoicePaymentUrl(invoiceId));
  }

  async sendInvoicePaymentSms(invoiceId) {
    return api.post(getInvoicePaymentSmsUrl(), { invoiceId });
  }

  async reduceInvoice(item) {
    return api.put(getInvoiceCrodUrl(), item);
  }

  async issueInvoice(item) {
    return api.post(getInvoiceCrodUrl(), item);
  }

  async getInvoice(invoiceId) {
    const params = {
      size: 1,
      offset: 0,
      id: invoiceId, // id test 148728
    };
    return api.get(getInvoiceSaleListUrl(), { params }).then((res) => res.data);
  }

  async getInvoiceSecondary(invoiceId) {
    const url = getReportSaleInvoiceUrl()+'?page=0&size=10';
    const params = {
      page: 0,
      size: 10,
    };
    const data = {
      filterVOS: {
        id: '1349',
        key: 'invoiceId',
        value: invoiceId,
      },
    };
    return api.post(url, data, { params }).then((res) => res.data);
  }
}

export default new InvoiceServices();
